import React from 'react'
import { useRouter } from 'next/router'
import { EmtFloatingIconButton } from 'emt-components-v2'

type Props = {
  baseBackUrl?: string
  forceBaseLink?: boolean
  color?: string
}

const BackButton: React.FC<Props> = ({ baseBackUrl = '/', forceBaseLink = false, color = 'primary' }) => {
  const router = useRouter()

  const onGoBack = React.useCallback(() => {
    if (router.asPath.includes('url_origin')) return router.replace(baseBackUrl)
    if (router.asPath.includes('utm_source')) return router.replace(baseBackUrl)
    if (forceBaseLink) return router.replace(baseBackUrl)

    return router.back()
  }, [])

  return (
    <EmtFloatingIconButton
      boxShadow
      iconClass="emt-arrow-left"
      sx={{
        cursor: 'pointer',
        width: '40px',
        height: '40px',
        '& .emt-icons': { fontSize: '18px', color: color },
        flexShrink: 0,
      }}
      onClick={onGoBack}
    />
  )
}

export default BackButton
